// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"298ce698","61":"a73d7d13","438":"9335141d","485":"409734bf","529":"19346759","535":"0b829a2f","626":"ac42dbf0","741":"e19e26fa","807":"ab4e9783","908":"7dc4565c"}[chunkId] + ".chunk.js";
};